// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LsANL","darkCaret":"styles_darkCaret__goFXh"};